import { render, staticRenderFns } from "./MultipurposeRoom.vue?vue&type=template&id=6e93c5f5&scoped=true"
import script from "./MultipurposeRoom.vue?vue&type=script&lang=js"
export * from "./MultipurposeRoom.vue?vue&type=script&lang=js"
import style0 from "./MultipurposeRoom.vue?vue&type=style&index=0&id=6e93c5f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e93c5f5",
  null
  
)

export default component.exports